import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { FullUserData } from 'src/app/Modules/management/models/organization/fullUserData.model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { SubHeaderData } from '../../../informate/models';
import { UserSettingModel } from '../../models/informate';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-settings-profile',
    templateUrl: './settings-profile.component.html',
    styleUrls: ['./settings-profile.component.scss'],
})
export class SettingsProfileComponent implements OnInit {
    subHeaderData: SubHeaderData;
    UserData: FullUserData;
    userFormData: FormData;
    isTelephoneChanged: boolean;
    isLanguageChanged: boolean;
    isFirstNameChanged: boolean;
    isLastnameChanged: boolean;
    languageSettingValueId: string;
    profileSettingAreaId: string;
    selectedLanguage: string;
    getEmailandNotifications: UserSettingModel[];
    isEmailNotificationVisible: boolean;
    editProfileForm: UntypedFormGroup;
    emailAndNotiResult: any;
    isProfileEdited: boolean;
    viewEmailData: boolean;

    constructor(
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
                 private translocoService: TranslocoService
    ) {}

    async ngOnInit(): Promise<void> {
        this.subHeaderData = this.setSubHeaderValues();
        this.globalEmittersService.profileDetails.subscribe((res) => {
            if (res) {
                this.UserData = res;
            }
        });

        this.isEmailNotificationVisible = await this.user_utility.checkUserPermissionDataAndRoute('profile-email-notification-setting', userActions.View);
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText =  this.translocoService.translate('HOME_PAGE.HEADER.IDMS_DROPDOWN.LINK.USER_PROFILE');
         headerData.displayTitle =  'User Profile';
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/user-profile-black.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/user-profile-yellow.png';
        return headerData;
    }

    editProfileFormEmitterhandler($event) {
        this.editProfileForm = $event;
    }
}
